import React, { type FC } from 'react';

// @ts-expect-error - TS2305 - Module '"@atlaskit/onboarding"' has no exported member 'SpotlightProps'.
import { Spotlight, type SpotlightProps } from '@atlaskit/onboarding';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { ShortcutScope } from '@atlassian/jira-common-components-keyboard-shortcuts';
import { borderRadius, gridSize } from '@atlassian/jira-common-styles/src';

const DIALOG_WIDTH = 41 * gridSize;

export type DefaultProps = {
	targetBgColor: SpotlightProps['targetBgColor'];
	targetRadius: SpotlightProps['targetRadius'];
	dialogWidth: SpotlightProps['dialogWidth'];
};

const defaultProps: DefaultProps = {
	targetBgColor: token('elevation.surface', colors.N20),
	targetRadius: borderRadius,
	dialogWidth: DIALOG_WIDTH,
};

type PropsIncludingDefaults = SpotlightProps & DefaultProps;

const spotlightWithDefaults =
	(defaults: DefaultProps): FC<PropsIncludingDefaults> =>
	(props: PropsIncludingDefaults) => {
		const { children, ...rest } = props;
		return (
			<ShortcutScope>
				<Spotlight {...defaults} {...rest}>
					{children}
				</Spotlight>
			</ShortcutScope>
		);
	};

export const StyledSpotlight = spotlightWithDefaults(defaultProps);
